import Container from './AppContainer';

export default Container;
